import type { MfaSetupResponse } from "common";
import { QRCodeSVG } from "qrcode.react";
import type { JSX } from "react";

const groupKey = (secret: string) =>
  secret.match(/.{1,4}/g)?.join(" ") ?? secret;

/** The QR code of a pending factor, and its key in groups of four for typing by hand. */
export default function AuthenticatorQr({
  setup,
}: {
  setup: Pick<MfaSetupResponse, "otpauthUri" | "secret">;
}): JSX.Element {
  return (
    <>
      <div className="flex justify-center">
        <QRCodeSVG
          value={setup.otpauthUri}
          size={192}
          aria-label="QR code for your authenticator app"
        />
      </div>
      <p className="text-center text-sm text-gray-600">
        Cannot scan it? Enter this key instead:{" "}
        <code data-testid="mfa-manual-key" className="font-mono">
          {groupKey(setup.secret)}
        </code>
      </p>
    </>
  );
}
